// extracted by mini-css-extract-plugin
export default {"container":"signup_container__PIjnw","card":"signup_card__Vw1++","title":"signup_title__OmGwZ","link":"signup_link__nJ7ns","button":"signup_button__CGpjy"};